export default __webpack_public_path__ + "static/media/mq.e5b6ce6d.svg";